module.exports = __webpack_public_path__ + "img/icon-pencil.d6aeac7f.svg";